import { PropsWithChildren } from 'react';

export function Centered({ children }: PropsWithChildren) {
  return (
    <div className="flex h-full w-full items-center justify-center">
      {children}
    </div>
  );
}
